import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

const SuspendModal = ({ isOpen, toggle, tagId, tagName, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!reason.trim()) {
      alert("Please provide a reason for suspension");
      return;
    }

    setLoading(true);
    try {
      await onConfirm(reason.trim());
      setReason("");
      toggle();
    } catch (error) {
      console.error("Error suspending hotspot:", error);
      alert(error.response?.data?.message || error.message || "Failed to suspend hotspot");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setReason("");
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered>
      <form onSubmit={handleSubmit}>
        <ModalHeader toggle={handleClose} className="bg-danger text-white">
          <i className="mdi mdi-alert-circle me-2"></i>
          Suspend Hotspot
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <p className="mb-0">
              Are you sure you want to suspend this hotspot?
            </p>
            {tagId && (
              <small className="text-muted">Tag ID: {tagId} - {tagName}</small>
            )}
          </div>

          <FormGroup>
            <Label>Reason for Suspension <span className="text-danger">*</span></Label>
            <Input
              type="textarea"
              rows="4"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter the reason for suspending this hotspot..."
              required
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button color="danger" type="submit" disabled={loading || !reason.trim()}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Suspending...
              </>
            ) : (
              <>
                <i className="mdi mdi-alert-circle me-2"></i>
                Suspend
              </>
            )}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default SuspendModal;

